import { UiComponents } from "@simulanisindia/ui";

const { GridView, ApplicationLoadCard } = UiComponents;

const ApplicationSkeleton = ({ length = 4 }) => {
    return (
        <>
            <GridView>
                {Array.from({ length: length }).map((_, index) => (
                    <ApplicationLoadCard />
                ))}
            </GridView>
        </>
    )
}

export default ApplicationSkeleton;